import events from '../events/events';
import store from '../vuex/store';
import CONST from '../constants';
import * as Sentry from '@sentry/vue';

const Loader = {};
const minPendingDelay = 450;
const loading = {};

/**
 * Template example with static identifier:
 * <div v-loader.areaIdentifier="{ class: 'class1 class2' }"></div>
 *
 * Template example with dynamic identifier:
 * <div v-loader="{ listen: dynamicAreaIdentifier, class: 'class1 class2' }"></div>
 */

/**
 * Return waiting time for loader to appear earliest
 */
function getPendingDelay(obj)
{
    if (typeof obj.value !== 'undefined' && obj.value.hasOwnProperty('delay'))
    {
        return obj.value.delay;
    }

    return minPendingDelay;
}

/**
 * Get classes from dom element having the v-loader directive
 *
 * @param obj
 * @returns {Array}
 */
function getClasses(obj)
{
    let classes = [];
    // Collect classes
    if (typeof obj.value !== 'undefined' && obj.value.hasOwnProperty('class'))
    {
        classes = obj.value.class.split(' ');
    }

    return classes;
}

/**
 * Injects the loader markup into the specified area
 *
 * @param obj
 * @param el
 * @param area
 */
function showLoader(obj, el, area)
{
    try
    {
        if (typeof el === 'undefined') return

        // Create loader html
        let e = document.createElement('div'),
            classes = getClasses(obj);

        e.innerHTML = `
        <div class="rotate">
            <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
            </svg>
        </div>`;

        e.classList.add('loader');
        e.classList.add('loader-inline');
        e.classList.add('loader-' + area);

        // Add optional classes to root element
        for (let i = 0; i < classes.length; i++)
        {
            el.classList.add(classes[i]);
        }

        // Add optional styles
        if (typeof obj.value !== 'undefined' &&
            obj.value.hasOwnProperty('style'))
        {
            e.style = obj.value.style;
        }

        el.append(e);
    }
    catch (e)
    {
        // Sentry.captureException(e);
    }
}

/**
 * @param obj
 * @param el
 * @param area
 */
function hideLoader(obj, el, area)
{
    let loader = el.querySelectorAll('.loader-' + area),
        classes = getClasses(obj);

    for (let i = 0; i < loader.length; i++)
    {
       loader[i].parentNode.removeChild(loader[i]);

        // Remove optional classes from root element
        for (let k = 0; k < classes.length; k++)
        {
            el.classList.remove(classes[k]);
        }
    }
}

/**
 * Loader plugin
 *
 * @param Vue
 * @param options
 */
Loader.install = function(Vue, options)
{
    let methods =
    {
        up()
        {
            store.dispatch('loader/up');
        },

        down()
        {
            store.dispatch('loader/down');
        },


        areaUp(area)
        {
            store.dispatch('loader/areaUp', area);
        },

        areaDown(area)
        {
            store.dispatch('loader/areaDown', area);
        }
    };

    // register global methods
    Vue.loader = methods;

    // register instance methods
    Vue.prototype.$loader = methods;

    Vue.directive('loader',
    {
        inserted(el, binding, vnode)
        {
            let watchers = [];
            // Get static modifiers
            if (typeof binding.modifiers !== 'undefined') watchers = Object.keys(binding.modifiers);
            // Get dyn. watchers
            if (typeof binding.value !== 'undefined' && binding.value.hasOwnProperty('listen'))
            {
                watchers = watchers.concat(binding.value.listen);
            }

            if (watchers.length > 0)
            {
                for (let k in watchers)
                {
                    events.$on(CONST.loaderPrefix + watchers[k], (event) =>
                    {
                        if (event === 'on')
                        {
                            loading[watchers[k]] = window._.debounce(() =>
                            {
                                showLoader(binding, el, watchers[k]);
                                delete loading[watchers[k]];
                            }, getPendingDelay(binding));

                            loading[watchers[k]]();
                        }

                        if (event === 'off')
                        {
                            let delay = getPendingDelay(binding);

                            if (typeof loading[watchers[k]] !== 'undefined')
                            {
                                loading[watchers[k]].cancel();
                                delay = 0;
                            }

                            window._.debounce(() =>
                            {
                                hideLoader(binding, el, watchers[k]);
                            }, delay)();
                        }
                    })
                }
            }
        },

        unbind(el, binding, vnode)
        {
            let watchers = Object.keys(binding.modifiers);

            if (watchers.length > 0)
            {
                for (let k in watchers)
                {
                    events.$off(CONST.loaderPrefix + watchers[k]);
                }
            }
        }
    });
};

export default Loader;



// WEBPACK FOOTER //
// ./src/js/plugins/loader.js